<template>
  <div class="flex flex-wrap gap-2 lg:gap-4">
    <slot />
  </div>
</template>
